/**
 * @file Scroll to top button.
 */

import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

import Button from './Button';
import ArrowLeft from '../icons/ArrowLeft';

const ScrollUp = loadable(() => import('react-scroll-up'), { ssr: false });

const propTypes = {
  showUnder: PropTypes.number,
  duration: PropTypes.number,
};

const ScrollToTopButton = ({ showUnder = 150, duration, ...props }) => (
  <ScrollUp showUnder={showUnder} duration={duration} {...props}>
    <Button btnStyle="reset" className="scroll-top-btn">
      <ArrowLeft color="#0f84fe" className="scroll-top-arrow" />
    </Button>
  </ScrollUp>
);

ScrollToTopButton.propTypes = propTypes;

export default ScrollToTopButton;
